import React from "react";

import { EntityCard } from "./EntityCard";
import { EntityGroup, EntityGroupContext } from "./EntityGroup";
import { EntityProperty } from "./EntityProperty";
import { EntitySeparator } from "./EntitySeparator";

export interface IEntity {
  Group: typeof EntityGroup;
  Card: typeof EntityCard;
  Property: typeof EntityProperty;
  Separator: typeof EntitySeparator;
}

export const Entity: IEntity = {
  Group: EntityGroup,
  Card: EntityCard,
  Property: EntityProperty,
  Separator: EntitySeparator,
};

export const useEntityGroupContext = () => React.useContext(EntityGroupContext);
